<template>
  <div>
    <Head title="Stocktake" />
    <h1 class="mb-8 text-3xl font-bold">Stocktake: {{ slug }}</h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block text-gray-700">Status:</label>
      </search-filter>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-3 pt-3 px-3">Date</th>
          <th class="pb-3 pt-3 px-3">Coverage</th>
          <th class="pb-3 pt-3 px-3">Cycle</th>
          <th class="pb-3 pt-3 px-3">Tag</th>
          <th class="pb-3 pt-3 px-3">Location</th>
          <th class="pb-3 pt-3 px-3" colspan="2">Status</th>
        </tr>
        <tr v-for="stocktake in stocktakes.data" :key="stocktake.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-3 py-3" :href="`/stocktake-references/${stocktake.id}/features/${slug}`" tabindex="-1">
              {{ stocktake.date }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3" :href="`/stocktake-references/${stocktake.id}/features/${slug}`" tabindex="-1">
              {{ stocktake.coverage }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3" :href="`/stocktake-references/${stocktake.id}/features/${slug}`" tabindex="-1">
              {{ stocktake.cycle }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3" :href="`/stocktake-references/${stocktake.id}/features/${slug}`" tabindex="-1">
              {{ stocktake.tag }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3" :href="`/stocktake-references/${stocktake.id}/features/${slug}`" tabindex="-1">
              {{ stocktake.location }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3" :href="`/stocktake-references/${stocktake.id}/features/${slug}`" tabindex="-1">
              {{ stocktake.status === 1 ? 'On' : 'Off' }}
            </Link>
          </td>
          <td class="w-px border-t">
            <Link class="flex items-center px-3" :href="`/stocktake-references/${stocktake.id}/features/${slug}`" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
        </tr>
        <tr v-if="stocktakes.data.length === 0">
          <td class="px-3 py-3 border-t" colspan="4">No data found</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="stocktakes.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import Pagination from '@/Shared/Pagination'

export default {
  components: {
    Head,
    Icon,
    Link,
    SearchFilter,
    Pagination,
  },
  layout: Layout,
  props: {
    filters: Object,
    stocktakes: Object,
    feature: String,
    slug: String,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get(`/stocktake-references/features/${this.slug}`, pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
